/* eslint-disable */
import React from 'react'
import moment from 'moment'
import { useLocation, useHistory } from 'react-router-dom'
import { DatePicker } from 'antd'
import { stringify } from '../../utils/querystring'

const { RangePicker } = DatePicker

const DateFilter = ({ startDate, endDate }) => {
    const location = useLocation()
    const history = useHistory()

    const startDateAsMoment = startDate && moment(startDate)
    const endDateAsMoment = endDate && moment(endDate)

    const updateRoute = (startDate, endDate) => {
        const pathname = location.pathname

        const query = {}
        if (startDate) query.startDate = moment(startDate).format('YYYYMMDD')
        if (endDate) query.endDate = moment(endDate).format('YYYYMMDD')

        const querystring = stringify(query)

        if (querystring) {
            history.push(`${pathname}?${querystring}`)
        } else {
            history.push(pathname)
        }
    }

    const handleOnChange = dataMoment => {
        updateRoute(dataMoment[0], dataMoment[1])
    }

    return (
        <div>
            <RangePicker
                value={[startDateAsMoment, endDateAsMoment]}
                format="DD MMM YYYY"
                onChange={handleOnChange}
            />
        </div>
    )
}

export default DateFilter
